export default __webpack_public_path__ + "img/f0f3d83aebb1ab9906b9012cd527fe32.png";